import { render, staticRenderFns } from "./handpickArticleList.vue?vue&type=template&id=02409962&scoped=true&"
import script from "./handpickArticleList.vue?vue&type=script&lang=js&"
export * from "./handpickArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02409962",
  null
  
)

export default component.exports